import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import PageControl from 'designer/component/control/page/ColorPickerControl'
import FavoriteControl from 'designer/component/control/favorite/ColorPickerControl'

export const ColorPickerSystem = (props) => (
  <DragElementWrapper {...props}>
    <PageControl {...props} />
  </DragElementWrapper>
)

export const ColorPickerDisplay = (props) => (
  <ElementWrapper {...props}>
    <PageControl {...props} />
  </ElementWrapper>
)

export const FavoriteColorPicker = (props) => (
  <ElementWrapper {...props}>
    <FavoriteControl {...props} />
  </ElementWrapper>
)

export const colorPickerTester = rankWith(1000, scopeEndsWith('colorPicker'))
